import React, { useState } from "react";
import { Form, Input, Button, Card } from "antd";
import API from "../api/axios";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const res = await API.post("/auth/login", values);
      // localStorage.setItem("token", res.data.token);
      // localStorage.setItem("role", res.data.user.role);
      // localStorage.setItem("schoolId", res.data.user.school_id);
      localStorage.setItem("token", res.data.token);
localStorage.setItem("user", JSON.stringify(res.data.user)); // ✅ Fixed — saves user object

      navigate("/dashboard");
    } catch (err) {
      alert("Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display:"flex", justifyContent:"center", alignItems:"center", height:"100vh" }}>
      <Card title="School Admin Login" style={{ width: 300 }}>
        <Form onFinish={onFinish}>
          <Form.Item name="username" rules={[{ required: true }]}>
            <Input placeholder="Username" />
          </Form.Item>
          <Form.Item name="password" rules={[{ required: true }]}>
            <Input.Password placeholder="Password" />
          </Form.Item>
          <Button type="primary" htmlType="submit" loading={loading} block>
            Login
          </Button>
        </Form>
      </Card>
    </div>
  );
}
